import { DIRECTION } from '@/store/types';

export default {
  computed: {
    dir() {
      return this.$store.getters[DIRECTION];
    },
  },
};
